// extracted by mini-css-extract-plugin
export default {"allContainer":"CardSuccesPayment_allContainer__Ayk2D","cardContent":"CardSuccesPayment_cardContent__s93Wn"};